/**
 * An instance of this is used by TaxSummary models, and the same instance
 * should be used for all the TaxSummary's on the same receipt.
 *
 * First the `addRate` method should be called for each taxReceipt in play on a receipt.
 * This will generate letters for each tax rate and also ensure the letters are sorted
 * by rate.
 *
 * After that, the getLetterForRate method should be called to get the letter.
 * If you call getLetterForRate and later call addRate you might get a letter than changes later.
 */
const { alphabet } = require('@/functions/strings');

class TaxRateLetters {
    constructor() {
        /**
         * @type {{taxRate: number, letter: string}[]}
         */
        this.taxRateLetters = [];
    }

    /**
     * @param {number} taxRate
     */
    addRate(taxRate) {
        if (this.getLetterForRate(taxRate)) {
            return;
        }

        this.taxRateLetters.push({
            taxRate,
            letter: '',
        });

        this.regenerateLetters();
    }

    /**
     * @param {number} taxRate
     *
     * @return {string|null}
     */
    getLetterForRate(taxRate) {
        const result = this.taxRateLetters.find((entry) => entry.taxRate === taxRate);

        return result ? result.letter : null;
    }

    /**
     * @private
     */
    regenerateLetters() {
        // Sort by tax rate.
        this.taxRateLetters.sort((a, b) => (a.taxRate > b.taxRate ? 1 : -1));

        let nextLetterIndex = 0;
        this.taxRateLetters.forEach((entry) => {
            entry.letter = alphabet[nextLetterIndex];
            nextLetterIndex += 1;
        });
    }
}

module.exports = TaxRateLetters;
